import { useIsPreviewPanelOpen } from '@atlassian/preview-panels-api/use-is-preview-panel-open';

import { PANEL_ID_BASE } from './previewPanelConstants.ts';

export const getTeamworkGraphPreviewPanelId = (contentId?: string): string =>
	contentId ? `${PANEL_ID_BASE}_${contentId}` : PANEL_ID_BASE;

export const useIsTeamworkGraphPreviewPanelOpen = (contentId?: string): boolean =>
	useIsPreviewPanelOpen(getTeamworkGraphPreviewPanelId(contentId));
